import { ACCEPTED_MIME_TYPES, MAX_FILE_SIZE_BYTES, MAX_FILE_SIZE_LABEL } from '@/constants/file-upload.ts';

const MAX_FILE_NAME_LENGTH = 255;

export const sanitizeFileName = (name: string): string => {
    const lastSeparator = Math.max(name.lastIndexOf('/'), name.lastIndexOf('\\'));
    const baseName = lastSeparator >= 0 ? name.slice(lastSeparator + 1) : name;
    return baseName.slice(0, MAX_FILE_NAME_LENGTH);
};

export const validateFile = (file: File): string | undefined => {
    const fileName = file.name.toLowerCase();
    const allowedExtensions = ACCEPTED_MIME_TYPES[file.type];

    if (!allowedExtensions) {
        return `Dateityp "${file.type || 'unbekannt'}" wird nicht unterstützt. Erlaubt: PDF, JPG, JPEG, PNG.`;
    }

    const hasValidExtension = allowedExtensions.some((ext) => fileName.endsWith(ext));
    if (!hasValidExtension) {
        return `Dateiendung wird nicht unterstützt. Erlaubt: PDF, JPG, JPEG, PNG.`;
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
        return `Die Datei "${file.name}" ist zu groß. Maximale Größe: ${MAX_FILE_SIZE_LABEL}.`;
    }
    return undefined;
};
